"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 1rem 0;\n\n  & [data-meta='add-button'] {\n    width: 100%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var text_scenario_node_styles_1 = require("../text-scenario-node/text-scenario-node.styles");

exports.StyledEditableTextNodeDiv = styled_components_1.default(text_scenario_node_styles_1.StyledTextNodeDiv)(_templateObject());
exports.StyledEditableTextNodeHeaderDiv = styled_components_1.default(text_scenario_node_styles_1.StyledTextNodeHeaderDiv)(_templateObject2());
exports.StyledEditableTextNodeBodyDiv = styled_components_1.default(text_scenario_node_styles_1.StyledTextNodeBodyDiv)(_templateObject3());
exports.AddOptionWrapperDiv = styled_components_1.default.div(_templateObject4());